import { logLevel } from '@/logger/constants'
import { contextManager } from '@/logger/context-manager'
import { SentryTransport } from '@/logger/transports/sentry'
import { LogLayer, LogLayerTransport } from 'loglayer'

const transport: LogLayerTransport[] = []

if (__DEV__) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { TsLogTransport } = require('@/logger/transports/tslog')
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { Logger } = require('tslog/dist/esm')

    transport.push(
        new TsLogTransport({ logger: new Logger({ prettyInspectOptions: { depth: 12 } }) })
    )
}

transport.push(new SentryTransport({ enabled: process.env.EXPO_PUBLIC_SENTRY_ENABLED === 'true' }))

export const logger = new LogLayer({
    copyMsgOnOnlyError: true,
    errorFieldName: 'error',
    contextFieldName: 'context',
    metadataFieldName: 'metadata',
    transport,
}).withContextManager(contextManager)

logger.setLevel(logLevel)
